module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-disabled-big.66efba67.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-disabled-big.png
// module id = 2635
// module chunks = 11